module.exports = __webpack_public_path__ + "prs-europe-large.jpg?15be395ba01cbfb6f9f841a648d89698";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prs-europe-large.jpg
// module id = 245
// module chunks = 0